import { useMemo } from 'react';
import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { usePageContext } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/page-context/main.tsx';

export const useContainerAri = () => {
	const cloudId = useCloudId();
	const [{ data: pageContextData }] = usePageContext();
	const { projectContext } = pageContextData || {};
	return useMemo(() => {
		return createAri({
			cloudId,
			resourceId: projectContext?.projectId?.toString() ?? '',
			resourceType: 'project',
			resourceOwner: 'jira',
		});
	}, [cloudId, projectContext?.projectId]);
};
